const REQUEST_FAILED_MESSAGE_START = 'Request failed with status code';

export const isNetworkRequestError = (error: Error): boolean => {
  return (
    error.name === 'Error' &&
    typeof error.message === 'string' &&
    error.message.includes(REQUEST_FAILED_MESSAGE_START)
  );
};
